export default __webpack_public_path__ + "static/media/033-tile.8801c61f.svg";